<template>
    <div style="width:100%">
        <div class="login-form-container__element--left -padding-bottom">
            <div class="log-reg-form--login validation-fields-container" novalidate spellcheck="false">
                <h2 class="log-reg-form__heading">{{ $t('DO_YOU_HAVE_ACCOUNT_LOGIN') }}</h2>
                <ul class="log-reg-form__column">
                    <li class="log-reg-form__list">
                        <div id="loginValidationContainer" class="validation-texts-container">
                            <p
                                class="validation-texts-container__text validation-texts-container__text--required-fields"
                            >
                                {{ $t('FILL_CORRECTLY_ALL_FIELDS') }}
                            </p>
                            <p
                                class="validation-texts-container__text validation-texts-container__text--wrong-login-data"
                            >
                                {{ loginFailedMessage }}
                            </p>
                            <p class="validation-texts-container__text validation-texts-container__text--not-activated">
                                {{ loginFailedMessage }}
                            </p>
                        </div>
                    </li>
                    <li class="log-reg-form__list">
                        <input
                            v-model.trim="username"
                            @keyup="inputKeyUp"
                            :placeholder="$t('EMAIL_ADDRESS')"
                            name="username"
                            type="text"
                            required
                            class="validate-email log-reg-form__input text-input -grey-input"
                        />
                    </li>
                    <li class="log-reg-form__list">
                        <input
                            v-model.trim="password"
                            @keyup.enter="login"
                            @keyup="inputKeyUp"
                            :placeholder="$t('PASSWORD')"
                            name="password"
                            type="password"
                            required
                            id="passwordInput"
                            class="log-reg-form__input text-input -grey-input"
                        />
                        <span
                            ><i
                                @click="showPassword"
                                class="glyphicon glyphicon-eye-open"
                                style="margin-left:-40px; cursor:pointer;display:initial"
                            ></i
                        ></span>
                    </li>
                    <li class="log-reg-form__list--remind">
                        <router-link to="/przypomnij-haslo" tag="button" class="log-reg-form__remind-password"
                            >{{ $t('RESET_PASSWORD') }}
                        </router-link>
                    </li>
                    <li class="log-reg-form__list--remind">
                        <router-link to="/wyslij-kod-aktywacyjny" tag="button" class="log-reg-form__remind-password"
                            >{{ $t('SEND_ACTIVATION_LINK_AGAIN') }}
                        </router-link>
                    </li>
                    <li class="log-reg-form__list">
                        <button @click="login" id="loginBtn" class="buttons-container__button -button-red">
                            {{ $t('LOGIN') }}
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { config, init } from './../../../main';
import { setToken, checkToken } from './../../../assets/js/tokenUtils';
import { validate } from './../../../validation';
import { sha256 } from 'js-sha256';
import Modal from '../../modals/_modal.vue';
import dataUrl from '../../../config.vue';

export default {
    components: {
        Modal,
    },
    data() {
        return {
            username: '',
            password: '',
            formSubmitted: false,
            loginFailedMessage: '',
        };
    },
    methods: {
        showPassword() {
            if (document.getElementById('passwordInput').type === 'password') {
                document.getElementById('passwordInput').type = 'text';
            } else {
                document.getElementById('passwordInput').type = 'password';
            }
        },
        performValidation() {
            return validate($('#loginBtn'));
        },
        inputKeyUp() {
            if (this.formSubmitted) {
                $('#loginValidationContainer').removeClass('show show-email');
                return this.performValidation();
            }
        },
        login() {
            if (this.performValidation()) {
                const loginData = {
                    client_id: config.client_id,
                    client_secret: config.client_secret,
                    grant_type: 'password',
                    username: sha256(this.username.toLowerCase()),
                    password: this.password,
                };
                this.$http
                    .post(`${config.authUrl}/oauth/token`, null, { params: loginData })
                    .then(this.userLoggedIn)
                    .catch(this.userFailedToLogIn);
            }
            this.formSubmitted = true;
        },

        userLoggedIn({ data }) {
            const localToken = dataUrl.data().myUrls.localUrl;
            const tokenUrl = checkToken(data);
            if (tokenUrl === localToken) {
                setToken(data);
                const redirectUrlAfterLogin = this.$cookie.get('redirectUrlAfterLogin');
                if (redirectUrlAfterLogin != null) {
                    if (!redirectUrlAfterLogin.includes('/wyniki-badan/')) {
                        this.$cookie.delete('redirectUrlAfterLogin');
                    }
                    window.location.href = redirectUrlAfterLogin;
                } else {
                    window.location.href = '/moje-konto';
                }
            } else {
                alert('Wrong Braster Server');
            }
        },
        userFailedToLogIn({ data }) {
            if (data.error_description === 'Bad credentials') {
                this.loginFailedMessage = this.$t('EMAIL_OR_PASSWORD_IS_INCORRECT');
                $('#loginValidationContainer').addClass('show show-email');
            } else if (data.error_description === 'USER_CANNOT_BE_LOGGED') {
                this.handleUserCannotBeLogged();
            }
        },
        handleUserCannotBeLogged() {
            const loginData = {
                username: sha256(this.username.toLowerCase()),
                password: this.password,
            };
            this.$http.post('/user/public/registration/blockDetails', loginData).then(({ data }) => {
                if (data.blocked) {
                    if (data.requestedForUnlock) {
                        this.$router.push('/prosba-wyslana');
                    } else {
                        this.$router.push({
                            path: 'konto-nieaktywne',
                            query: {
                                ...loginData,
                                dateDeactivated: data.blockDate,
                            },
                        });
                    }
                    init();
                } else {
                    this.loginFailedMessage = this.$t('ACCOUNT_IS_INACTIVE');
                    $('#loginValidationContainer').addClass('show show-email');
                }
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// login.vue?69a3c1fa